export default "__VITE_ASSET__BVa029uR__"